import qwest from 'qwest';
import querystring from 'querystring';

export function find(branches, field, find, partial, sort, sortDirection, page) {
  return qwest.post('/DataCleanup/Find', {
    branches,
    field,
    find,
    sort,
    sortDirection,
    page,
    partial: partial === 1 || partial === '1',
  })
    .then((xhr, res) => {
      return res.data;
    });
}

export function findAll(branches, field, find, partial, sort, sortDirection) {
  return qwest.post('/DataCleanup/FindAll', {
    branches,
    field,
    find,
    sort,
    sortDirection,
    partial: partial === 1 || partial === '1',
  })
    .then((xhr, res) => {
      return res.data;
    });
}

export function replace(branches, field, find, partial, replace, selected) {
  return qwest.post('/DataCleanup/Replace', {
    branches,
    field,
    find,
    partial: partial === 1 || partial === '1',
    replace,
    selected,
  })
    .then((xhr, res) => {
      return res.data;
    });
}

export function getUnverifiedAddresses({branches, sort, sortDirection, excludeAttempted, showInactive, page}) {
  return qwest.get('/DataCleanup/UnverifiedAddresses?' + querystring.stringify({branches, sort, sortDirection, excludeAttempted, page, showInactive}))
    .then((xhr, res) => res.data);
}

export function attemptedVerification(id) {
  return qwest.post('/DataCleanup/AttemptedVerification', {id})
    .then((xhr, res) => res.data);
}

export function getConjoinedContacts({branches, page, size, search, sort, sortDirection}) {
  return qwest.post('/DataCleanup/ConjoinedContacts', {
    branches,
    page,
    size,
    search,
    sort,
    sortDirection,
  })
    .then((xhr, res) => res.data);
}

export function demergeContact(original, newContacts, toDelete) {
  return qwest.post('/DataCleanup/DemergeContact', {
    original: original.toApiFormat(),
    newContacts: newContacts.map(x => x.toApiFormat()),
    toDelete,
  })
    .then((xhr, res) => res.data);
}

export function getDuplicateAccounts({page = 1, sortKey = 'score', sortDirection = 'desc', hideIgnored = true, search = ''}) {
  return qwest.get(`/DataCleanup/PossibleMerges?page=${page}` +
    `&sort=${sortKey !== 'Score.Total' ? sortKey : 'score'}` +
    `&sortDirection=${sortDirection}&hideIgnored=${hideIgnored}` +
    `&search=${search}`)
    .then((xhr, res) => res.data);
}

export function verifyAddress(address, id) {
  return qwest.post('/DataCleanup/VerifyAddress', {
    address,
    id,
  })
    .then((xhr, res) => res.data);
}

export function getMultipleSystems(branches, page, sort, sortDirection) {
  return qwest.post('/DataCleanup/MultipleSystems', {
    branches,
    page,
    sort,
    sortDirection,
  })
    .then((xhr, res) => res.data);
}


export function mergeSystems(master, other) {
  return qwest.post('/DataCleanup/MergeSystems', {
    other,
    master,
  })
    .then((xhr, res) => res);
}

export function mergeCustomers(newCustomer, originals) {
  return qwest.post('/DataCleanup/MergeCustomers', {
    newCustomer,
    originals,
  }).then((xhr, res) => res);
}

export function ignoreMerge(id1, id2) {
  return qwest.post('/DataCleanup/IgnoreMerge', {
    id1,
    id2,
  }).then((xhr, res) => res);
}
